// import React, { useState, useRef, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { Clock, MapPin, Smile, Fingerprint, Shield, Lock, CheckCircle, Gift, Eye, EyeOff, ChevronRight, ChevronLeft, Building2, User, Mail, Briefcase, Play, UserCog } from 'lucide-react';
// import BMLogo from '../../assets/Logo of CICO time (1).png';
// import { Signup, Login, Manager_Login } from "../../services/oprations/Auth";
// import StandardSpinner from "../../utils/Spinner";

// const AuthPages = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [message ,setMessage] = useState(null)
//   const [loading, setLoading] = useState(true);
//   const [isLogin, setIsLogin] = useState(true);
//   const [loginType, setLoginType] = useState("organization"); // "organization" or "manager"
//   const [showPassword, setShowPassword] = useState(false);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [fullName, setFullName] = useState("");
//   const [companyName, setCompanyName] = useState("");
//   const [jobTitle, setJobTitle] = useState("");
//   const [agreeTerms, setAgreeTerms] = useState(false);
  
//   const signupScrollRef = useRef(null);
//   const [activeStep, setActiveStep] = useState(1);

//   useEffect(() => {
//     setTimeout(() => {
//       setLoading(false);
//     }, 1000);
//   }, []);

//   const toggleAuthMode = (mode) => {
//     setIsLogin(mode === 'login');
//     setActiveStep(1);
//     // Reset form fields when switching modes
//     setEmail("");
//     setPassword("");
//     setConfirmPassword("");
//     setFullName("");
//     setCompanyName("");
//     setJobTitle("");
//     setAgreeTerms(false);
//     setLoginType("organization"); // Reset to organization when switching modes
//   };

//   const scrollToNext = () => {
//     if (signupScrollRef.current) {
//       signupScrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
//       setActiveStep(2);
//     }
//   };

//   const scrollToPrev = () => {
//     if (signupScrollRef.current) {
//       signupScrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
//       setActiveStep(1);
//     }
//   };

//   const handleOrganizationLogin = async (e) => {
//     e.preventDefault();
    
//     const loginData = {
//       org_email: email,
//       password: password
//     };

//     const res = await dispatch(Login(loginData, navigate));
//     setMessage({status:res.success,text:res.message})
//     setTimeout(()=>{
//       setMessage(null)
//     },2000)
//   };

//   const handleManagerLogin = async (e) => {
//     e.preventDefault();
    
//     const loginData = {
//       manager_email: email,  // Using manager_email for manager login
//       manager_password: password
//     };

//     const res = await dispatch(Manager_Login(loginData, navigate));
//     setMessage({status:res.success,text:res.message})

//     setTimeout(()=>{
//       setMessage(null)
//     },2000)
//   };

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     if (loginType === "organization") {
//       await handleOrganizationLogin(e);
//     } else {
//       await handleManagerLogin(e);
//     }
//   };

//   const handleSignup = async (e) => {
//     e.preventDefault();
    
//     // Validate passwords match
//     if (password !== confirmPassword) {
//       alert("Passwords don't match");
//       return;
//     }
//     // Prepare signup data according to API requirements
//     const signupData = {
//       org_name: fullName,
//       org_email: email,
//       password: password
//     };
//     // Dispatch signup action
//     await dispatch(Signup(signupData, navigate));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (isLogin) {
//       handleLogin(e);
//     } else {
//       handleSignup(e);
//     }
//   };

//   if (loading) {
//     return <StandardSpinner />
//   }

//   return (
//     <div className="min-h-screen font-sans bg-gradient-to-br from-[#0a0f1e] via-[#0b1425] to-[#0c1a2f] text-white overflow-hidden relative">
//       {/* Animated background orbs */}
//       <div className="absolute top-20 left-10 w-96 h-96 bg-blue-600/20 rounded-full blur-[100px] animate-pulse-slow"></div>
//       <div className="absolute bottom-20 right-10 w-96 h-96 bg-indigo-600/20 rounded-full blur-[100px] animate-pulse-slow animation-delay-2000"></div>
//       <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-500/10 rounded-full blur-[120px]"></div>
      
//       {/* Grid overlay */}
//
//       {/* Main Auth Container */}
//       <div className="container relative z-10 flex items-center min-h-screen px-6 mx-auto py-28">
//         <div className="flex flex-col items-center w-full gap-12 mx-auto lg:flex-row max-w-7xl">
          
//           {/* Left Side - 3D Logo with Circular Border */}
//           <div className="flex flex-col items-center flex-1 gap-8">
//             {/* 3D Animated Logo */}
//             <div className="relative w-80 h-80 lg:w-96 lg:h-96 animate-float-3d">
//               <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl rotate-6 transform-gpu animate-pulse-slow opacity-30 blur-3xl"></div>
//               <div className="absolute inset-0 overflow-hidden transition-all duration-700 border shadow-2xl bg-gradient-to-br from-blue-900/80 to-indigo-900/80 rounded-3xl transform-gpu rotate-3 hover:rotate-0 border-blue-500/30 backdrop-blur-sm">
//                 <div className="flex items-center justify-center w-full h-full bg-blue-500">
//                   <div className="p-8 text-center text-white">
//                     <div className="relative">
//                       {/* Circular Logo with Multiple Borders */}
//                       <div className="relative w-32 h-32 mx-auto">
//                         <div className="absolute inset-0 border-2 rounded-full border-blue-400/30 animate-spin-slow"></div>
//                         <div className="absolute inset-0 border-2 rounded-full border-indigo-400/50 animate-ping-slow"></div>
//                         <div className="absolute inset-0 rounded-full bg-blue-500/20 blur-xl animate-pulse"></div>
//                         <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 p-[3px]">
//                           <div className="w-full h-full rounded-full bg-[#0a0f1e] flex items-center justify-center overflow-hidden border-2 border-white/20">
//                             <img
//                               src={BMLogo}
//                               alt="AttendEase Logo"
//                               className="object-contain w-24 h-24 rounded-full animate-bounce-slow"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="grid grid-cols-3 gap-3 mt-6">
//                       <div className="p-3 border rounded-lg bg-white/80 backdrop-blur-sm animate-pulse border-blue-400/30">
//                         <User className="w-6 h-6 mx-auto text-blue-300" />
//                       </div>
//                       <div className="p-3 delay-100 border rounded-lg bg-white/80 backdrop-blur-sm animate-pulse border-blue-400/30">
//                         <MapPin className="w-6 h-6 mx-auto text-blue-300" />
//                       </div>
//                       <div className="p-3 delay-200 border rounded-lg bg-white/80 backdrop-blur-sm animate-pulse border-blue-400/30">
//                         <Clock className="w-6 h-6 mx-auto text-blue-300" />
//                       </div>
//                     </div>
//                     <div className="flex items-center justify-center gap-2 mt-6 text-sm">
//                       <span className="w-2 h-2 bg-green-400 rounded-full animate-ping"></span>
//                       <span className="font-semibold text-blue-100">Secure • Fast • Reliable</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Side - Fixed Height Form Container */}
//           <div className="flex-1 w-full max-w-md mx-auto lg:mx-0">
//             <div className="bg-gradient-to-br from-blue-900/40 to-indigo-900/40 backdrop-blur-xl rounded-3xl border border-blue-500/30 p-8 shadow-2xl h-[680px] flex flex-col hover:border-blue-500/50 transition-all">
              
//               {/* Header */}
//               <div className="flex-shrink-0 mb-4 text-center">
//                 <h2 className="text-3xl font-bold text-transparent bg-gradient-to-r from-white to-blue-200 bg-clip-text">
//                   {isLogin ? "Welcome Back!" : "Start Your Journey"}
//                 </h2>
//                 <p className="mt-2 text-sm text-blue-100/70">
//                   {isLogin 
//                     ? "Sign in to access your secure dashboard" 
//                     : "Create your account at AttendEase"}
//                 </p>
//               </div>

//               {/* Login Type Toggle - Only show for login */}
//               {isLogin && (
//                 <div className="flex-shrink-0 mb-4">
//                   <label className="block mb-2 text-xs font-medium text-center text-blue-100">
//                     Sign in as
//                   </label>
//                   <div className="flex gap-3">
//                     <button
//                       type="button"
//                       onClick={() => setLoginType("organization")}
//                       className={`flex-1 py-2.5 px-3 rounded-xl flex items-center justify-center gap-2 transition-all ${
//                         loginType === "organization"
//                           ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-500/30 border border-blue-400'
//                           : 'bg-white/5 hover:bg-white/10 text-blue-100 border border-blue-500/30 hover:border-blue-400/50'
//                       }`}
//                     >
//                       <Building2 className="w-4 h-4" />
//                       <span className="text-xs">Organization</span>
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => setLoginType("manager")}
//                       className={`flex-1 py-2.5 px-3 rounded-xl flex items-center justify-center gap-2 transition-all ${
//                         loginType === "manager"
//                           ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-500/30 border border-blue-400'
//                           : 'bg-white/5 hover:bg-white/10 text-blue-100 border border-blue-500/30 hover:border-blue-400/50'
//                       }`}
//                     >
//                       <UserCog className="w-4 h-4" />
//                       <span className="text-xs">Manager</span>
//                     </button>
//                   </div>
//                 </div>
//               )}

//               {/* Social Login */}
//               {/* <div className="flex flex-shrink-0 gap-3 mb-4">
//                 <button type="button" className="flex-1 py-2.5 px-3 bg-white/5 hover:bg-white/10 border border-blue-500/30 rounded-xl flex items-center justify-center gap-2 transition-all group hover:border-blue-400/50">
//                   <svg className="w-4 h-4 text-blue-400 transition group-hover:scale-110" viewBox="0 0 24 24">
//                     <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
//                     <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
//                     <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
//                     <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
//                   </svg>
//                   <span className="text-xs text-blue-100">Google</span>
//                 </button>
//                 <button type="button" className="flex-1 py-2.5 px-3 bg-white/5 hover:bg-white/10 border border-blue-500/30 rounded-xl flex items-center justify-center gap-2 transition-all group hover:border-blue-400/50">
//                   <svg className="w-4 h-4 text-blue-400 transition group-hover:scale-110" viewBox="0 0 24 24">
//                     <path fill="currentColor" d="M11.5 3.5c.8 0 1.6-.3 2.2-.8.6-.5 1-1.2 1.1-2 .4.1.8.3 1.1.5.9.6 1.5 1.5 1.7 2.6.2 1-.1 2-.7 2.8-.6.8-1.5 1.4-2.5 1.5 0-.3-.1-.6-.2-.9-.2-.7-.7-1.3-1.3-1.7-.6-.4-1.4-.6-2.1-.5.1-.5.3-.9.6-1.3.4-.5.9-.8 1.5-1zM21 17.5c-.3 1.3-1 2.4-1.9 3.3-.8.8-1.7 1.4-2.7 1.7-1 .3-2 .4-3 .2-1-.2-2-.6-3-1-.8-.3-1.6-.5-2.4-.5-.8 0-1.6.2-2.4.5-1 .4-2 .8-3 1-1 .2-2 .1-3-.2-1-.3-1.9-.9-2.7-1.7-1-.9-1.7-2-2-3.2-.3-1.3-.3-2.7 0-4 .3-1.3 1-2.4 1.9-3.3.6-.6 1.3-1.1 2.1-1.4.8-.3 1.7-.5 2.6-.4.5.1 1 .2 1.5.4.4.2.9.4 1.3.6.3-.1.6-.2.9-.3.8-.2 1.6-.3 2.4-.3.8 0 1.6.1 2.4.3.6.2 1.2.4 1.8.7.5-.3 1.1-.5 1.7-.7.8-.3 1.7-.4 2.6-.4.9 0 1.8.1 2.6.4.8.3 1.5.8 2.1 1.4.9.9 1.6 2 1.9 3.3.3 1.2.3 2.5 0 3.8z"/>
//                   </svg>
//                   <span className="text-xs text-blue-100">Microsoft</span>
//                 </button>
//               </div> */}

//               {/* Divider */}
//               <div className="relative flex-shrink-0 mb-4">
//                 <div className="absolute inset-0 flex items-center">
//                   <div className="w-full border-t border-blue-500/30"></div>
//                 </div>
//                 <div className="relative flex justify-center text-xs">
//                   <span className="px-4 bg-gradient-to-br from-blue-900/40 to-indigo-900/40 text-blue-200/60">
//                     {isLogin ? `sign in with ${loginType} email` : "sign up with email"}
//                   </span>
//                 </div>
//               </div>

//               {/* Form */}
//               <form onSubmit={handleSubmit} className="flex flex-col flex-1 min-h-0">
//                 <div className="flex-1 pr-1 overflow-y-auto custom-scrollbar">
//                   {!isLogin ? (
//                     <>
//                       {/* Signup Form (unchanged) */}
//                       <div className="space-y-3">
//                         {/* Steps Indicator */}

//                         {/* Scrollable Container */}
//                         <div 
//                           ref={signupScrollRef}
//                           className="flex overflow-x-hidden scroll-smooth"
//                           style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
//                         >
//                           {/* Step 1: Personal Info */}
//                           <div className="min-w-full pr-1 space-y-3 transition-all">
//                             <div>
//                               <label className="block mb-1 text-xs font-medium text-blue-100">
//                                 Full Name
//                               </label>
//                               <div className="relative group">
//                                 <User className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                                 <input
//                                   type="text"
//                                   value={fullName}
//                                   onChange={(e) => setFullName(e.target.value)}
//                                   className="w-full pl-9 pr-3 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                                   placeholder="John Doe"
//                                   required
//                                 />
//                               </div>
//                             </div>

//                             <div>
//                               <label className="block mb-1 text-xs font-medium text-blue-100">
//                                 Email Address
//                               </label>
//                               <div className="relative group">
//                                 <Mail className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                                 <input
//                                   type="email"
//                                   value={email}
//                                   onChange={(e) => setEmail(e.target.value)}
//                                   className="w-full pl-9 pr-3 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                                   placeholder="you@company.com"
//                                   required
//                                 />
//                               </div>
//                             </div>

//                             {/* <button
//                               type="button"
//                               onClick={scrollToNext}
//                               disabled={!fullName || !email}
//                               className={`w-full mt-2 py-2.5 px-4 text-sm bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white font-semibold rounded-xl transition-all flex items-center justify-center gap-2 shadow-lg shadow-blue-500/30 group ${
//                                 (!fullName || !email) ? 'opacity-50 cursor-not-allowed' : 'hover:scale-[1.02]'
//                               }`}
//                             >
//                               Continue
//                               <ChevronRight className="w-4 h-4 transition group-hover:translate-x-1" />
//                             </button> */}
//                           </div>

//                           {/* Step 2: Company Info */}
//                           {/* <div className="min-w-full pl-1 space-y-3 transition-all">
//                             <div>
//                               <label className="block mb-1 text-xs font-medium text-blue-100">
//                                 Company Name
//                               </label>
//                               <div className="relative group">
//                                 <Building2 className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                                 <input
//                                   type="text"
//                                   value={companyName}
//                                   onChange={(e) => setCompanyName(e.target.value)}
//                                   className="w-full pl-9 pr-3 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                                   placeholder="Acme Inc."
//                                 />
//                               </div>
//                             </div>

//                             <div>
//                               <label className="block mb-1 text-xs font-medium text-blue-100">
//                                 Job Title
//                               </label>
//                               <div className="relative group">
//                                 <Briefcase className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                                 <input
//                                   type="text"
//                                   value={jobTitle}
//                                   onChange={(e) => setJobTitle(e.target.value)}
//                                   className="w-full pl-9 pr-3 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                                   placeholder="Product Manager"
//                                 />
//                               </div>
//                             </div>

//                             <button
//                               type="button"
//                               onClick={scrollToPrev}
//                               className="w-full mt-2 py-2.5 px-4 text-sm border border-blue-500/30 hover:bg-white/10 text-blue-100 font-semibold rounded-xl transition-all flex items-center justify-center gap-2 group"
//                             >
//                               <ChevronLeft className="w-4 h-4 transition group-hover:-translate-x-1" />
//                               Back
//                             </button>
//                           </div> */}
//                         </div>

//                         {/* Scroll Indicators */}
//                         {/* <div className="flex justify-center gap-2 mt-2">
//                           <button
//                             type="button"
//                             onClick={scrollToPrev}
//                             disabled={activeStep === 1}
//                             className={`p-1.5 rounded-full transition-all ${
//                               activeStep === 1 
//                                 ? 'bg-white/5 text-blue-200/30 cursor-not-allowed' 
//                                 : 'bg-white/10 text-blue-400 hover:bg-white/20'
//                             }`}
//                           >
//                             <ChevronLeft className="w-3.5 h-3.5" />
//                           </button>
//                           <div className="flex gap-1.5 items-center">
//                             <div className={`w-1.5 h-1.5 rounded-full transition-all ${activeStep === 1 ? 'bg-blue-500 w-3' : 'bg-white/30'}`}></div>
//                             <div className={`w-1.5 h-1.5 rounded-full transition-all ${activeStep === 2 ? 'bg-blue-500 w-3' : 'bg-white/30'}`}></div>
//                           </div>
//                           <button
//                             type="button"
//                             onClick={scrollToNext}
//                             disabled={activeStep === 2 || !fullName || !email}
//                             className={`p-1.5 rounded-full transition-all ${
//                               activeStep === 2 || !fullName || !email
//                                 ? 'bg-white/5 text-blue-200/30 cursor-not-allowed' 
//                                 : 'bg-white/10 text-blue-400 hover:bg-white/20'
//                             }`}
//                           >
//                             <ChevronRight className="w-3.5 h-3.5" />
//                           </button>
//                         </div> */}

//                         {/* Password Fields */}
//                         <div className="pt-3 mt-3 space-y-3 border-t border-blue-500/20">
//                           <div>
//                             <label className="block mb-1 text-xs font-medium text-blue-100">
//                               Password
//                             </label>
//                             <div className="relative group">
//                               <Lock className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                               <input
//                                 type={showPassword ? "text" : "password"}
//                                 value={password}
//                                 onChange={(e) => setPassword(e.target.value)}
//                                 className="w-full pl-9 pr-9 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                                 placeholder="Create a strong password"
//                                 required
//                               />
//                               <button
//                                 type="button"
//                                 onClick={() => setShowPassword(!showPassword)}
//                                 className="absolute text-blue-400 transition transform -translate-y-1/2 right-3 top-1/2 hover:text-blue-300"
//                               >
//                                 {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
//                               </button>
//                             </div>
//                           </div>

//                           <div>
//                             <label className="block mb-1 text-xs font-medium text-blue-100">
//                               Confirm Password
//                             </label>
//                             <div className="relative group">
//                               <Lock className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                               <input
//                                 type={showPassword ? "text" : "password"}
//                                 value={confirmPassword}
//                                 onChange={(e) => setConfirmPassword(e.target.value)}
//                                 className="w-full pl-9 pr-3 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                                 placeholder="Confirm your password"
//                                 required
//                               />
//                             </div>
//                           </div>

//                           <div className="flex items-start gap-2">
//                             <input
//                               type="checkbox"
//                               id="terms"
//                               checked={agreeTerms}
//                               onChange={(e) => setAgreeTerms(e.target.checked)}
//                               className="w-3.5 h-3.5 mt-0.5 rounded border-blue-500/30 bg-white/5 text-blue-600 focus:ring-blue-500/20 focus:ring-offset-0"
//                               required
//                             />
//                             <label htmlFor="terms" className="text-xs text-blue-100/70">
//                               I agree to the{" "}
//                               <a href="#" className="text-blue-400 hover:text-blue-300">Terms</a>{" "}
//                               and{" "}
//                               <a href="#" className="text-blue-400 hover:text-blue-300">Privacy Policy</a>
//                             </label>
//                           </div>
//                         </div>
//                       </div>
//                     </>
//                   ) : (
//                     /* Login Form */
//                     <div className="pt-2 space-y-4">
//                       <div>
//                         <label className="block mb-1 text-xs font-medium text-blue-100">
//                           {loginType === "organization" ? "Organization Email" : "Manager Email"}
//                         </label>
//                         <div className="relative group">
//                           <Mail className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                           <input
//                             type="email"
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                             className="w-full pl-9 pr-3 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                             placeholder={loginType === "organization" ? "org@company.com" : "manager@company.com"}
//                             required
//                           />
//                         </div>
//                       </div>

//                       <div>
//                         <label className="block mb-1 text-xs font-medium text-blue-100">
//                           Password
//                         </label>
//                         <div className="relative group">
//                           <Lock className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                           <input
//                             type={showPassword ? "text" : "password"}
//                             value={password}
//                             onChange={(e) => setPassword(e.target.value)}
//                             className="w-full pl-9 pr-9 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                             placeholder="Enter your password"
//                             required
//                           />
//                           <button
//                             type="button"
//                             onClick={() => setShowPassword(!showPassword)}
//                             className="absolute text-blue-400 transition transform -translate-y-1/2 right-3 top-1/2 hover:text-blue-300"
//                           >
//                             {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
//                           </button>
//                         </div>
//                       </div>

//                       <div className="flex items-center justify-between">
//                         {/* <div className="flex items-center gap-2">
//                           <input
//                             type="checkbox"
//                             id="remember"
//                             className="w-3.5 h-3.5 rounded border-blue-500/30 bg-white/5 text-blue-600 focus:ring-blue-500/20 focus:ring-offset-0"
//                           />
//                           <label htmlFor="remember" className="text-xs text-blue-100/70">
//                             Remember me
//                           </label>
//                         </div> */}
//                         {/* <a href="#" className="text-xs text-blue-400 transition hover:text-blue-300">
//                           Forgot password?
//                         </a> */}
//                       </div>
//                       {/* Error Message*/}
//                        <div className="flex items-center justify-center">
//                         <span className={`text-xs ${message?.status?"text-green-400":"text-red-500"}`}>{message?.text}</span>
//                         </div>
                      
//                       {/* Spacing to match signup height */}
//                       <div className="h-[20px]"></div>
//                     </div>
//                   )}
//                 </div>

//                 {/* Submit Button */}
//                 <div className="flex-shrink-0 mt-4">
//                   <button
//                     type="submit"
//                     disabled={!isLogin && (!fullName || !email || !password || !confirmPassword || !agreeTerms)}
//                     className={`w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white font-semibold rounded-xl transition-all flex items-center justify-center gap-2 shadow-lg shadow-blue-500/30 ${
//                       !isLogin && (!fullName || !email || !password || !confirmPassword || !agreeTerms)
//                         ? 'opacity-50 cursor-not-allowed'
//                         : 'hover:scale-[1.02] active:scale-[0.98]'
//                     }`}
//                   >
//                     {isLogin ? (
//                       <>
//                         <Fingerprint className="w-4 h-4" />
//                         Sign In as {loginType === "organization" ? "Organization" : "Manager"}
//                       </>
//                     ) : (
//                       <>
//                         <User className="w-4 h-4" />
//                         Create Account
//                       </>
//                     )}
//                   </button>

//                   {/* Toggle Link */}
//                   {/* <div className="mt-3 text-center">
//                     <p className="text-xs text-blue-100/70">
//                       {isLogin ? "New to AttendEase?" : "Already have an account?"}
//                       <button
//                         type="button"
//                         onClick={() => toggleAuthMode(isLogin ? 'signup' : 'login')}
//                         className="ml-2 font-semibold text-blue-400 transition border-b hover:text-blue-300 border-blue-400/30 hover:border-blue-400"
//                       >
//                         {isLogin ? "Create free account" : "Sign in"}
//                       </button>
//                     </p>
//                   </div> */}

//                   {/* Free Trial Badge */}
//                   {/* {!isLogin && (
//                     <div className="p-3 mt-3 border bg-gradient-to-r from-blue-600/20 via-indigo-600/20 to-purple-600/20 rounded-xl border-blue-500/30">
//                       <div className="flex items-center gap-2">
//                         <Gift className="w-4 h-4 text-blue-400" />
//                         <div>
//                           <p className="text-xs font-semibold text-white">14-day free trial</p>
//                           <p className="text-[10px] text-blue-200/70">No credit card required</p>
//                         </div>
//                       </div>
//                     </div>
//                   )} */}
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Custom Scrollbar Styles */}
//       <style jsx>{`
//         .custom-scrollbar::-webkit-scrollbar {
//           width: 4px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-track {
//           background: rgba(59, 130, 246, 0.1);
//           border-radius: 10px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb {
//           background: rgba(59, 130, 246, 0.3);
//           border-radius: 10px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//           background: rgba(59, 130, 246, 0.5);
//         }
        
//         @keyframes float-3d {
//           0%, 100% { transform: translateY(0px) rotate(0deg); }
//           50% { transform: translateY(-20px) rotate(2deg); }
//         }
//         .animate-float-3d {
//           animation: float-3d 6s ease-in-out infinite;
//         }
//         @keyframes pulse-slow {
//           0%, 100% { opacity: 0.2; }
//           50% { opacity: 0.4; }
//         }
//         .animate-pulse-slow {
//           animation: pulse-slow 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
//         }
//         @keyframes ping-slow {
//           75%, 100% { transform: scale(1.5); opacity: 0; }
//         }
//         .animate-ping-slow {
//           animation: ping-slow 3s cubic-bezier(0, 0, 0.2, 1) infinite;
//         }
//         @keyframes bounce-slow {
//           0%, 100% { transform: translateY(0); }
//           50% { transform: translateY(-10px); }
//         }
//         .animate-bounce-slow {
//           animation: bounce-slow 3s infinite;
//         }
//         @keyframes spin-slow {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//         .animate-spin-slow {
//           animation: spin-slow 8s linear infinite;
//         }
//         .delay-100 {
//           animation-delay: 100ms;
//         }
//         .delay-200 {
//           animation-delay: 200ms;
//         }
//         .animation-delay-2000 {
//           animation-delay: 2000ms;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AuthPages;

// import React, { useState, useRef, useEffect } from "react";
// import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { Clock, MapPin, Smile, Fingerprint, Shield, Lock, CheckCircle, Gift, Eye, EyeOff, ChevronRight, ChevronLeft, Building2, User, Mail, Briefcase, Play, UserCog } from 'lucide-react';
// import BMLogo from '../../assets/Logo of CICO time (1).png';
// import { Signup, Login, Manager_Login } from "../../services/oprations/Auth";
// import { UserLogin } from "../../services/oprations/User_Bussiness_Logic";
// import StandardSpinner from "../../utils/Spinner";

// const AuthPages = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const [message ,setMessage] = useState(null)
//   const [loading, setLoading] = useState(true);
//   const [isLogin, setIsLogin] = useState(true);
//   const [loginType, setLoginType] = useState("organization"); // "organization" | "manager" | "user"
//   const [showPassword, setShowPassword] = useState(false);
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [fullName, setFullName] = useState("");
//   const [companyName, setCompanyName] = useState("");
//   const [jobTitle, setJobTitle] = useState("");
//   const [agreeTerms, setAgreeTerms] = useState(false);
  
//   const signupScrollRef = useRef(null);
//   const [activeStep, setActiveStep] = useState(1);

//   useEffect(() => {
//     setTimeout(() => {
//       setLoading(false);
//     }, 1000);
//   }, []);

//   // If a User session already exists, skip the login form and go straight to the portal
//   useEffect(() => {
//     const userToken = localStorage.getItem('userToken');
//     if (userToken) {
//       navigate('/dashboard', { replace: true });
//     }
//   }, [navigate]);

//   const toggleAuthMode = (mode) => {
//     setIsLogin(mode === 'login');
//     setActiveStep(1);
//     // Reset form fields when switching modes
//     setEmail("");
//     setPassword("");
//     setConfirmPassword("");
//     setFullName("");
//     setCompanyName("");
//     setJobTitle("");
//     setAgreeTerms(false);
//     setLoginType("organization"); // Reset to organization when switching modes
//   };

//   const scrollToNext = () => {
//     if (signupScrollRef.current) {
//       signupScrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
//       setActiveStep(2);
//     }
//   };

//   const scrollToPrev = () => {
//     if (signupScrollRef.current) {
//       signupScrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
//       setActiveStep(1);
//     }
//   };

//   const handleOrganizationLogin = async (e) => {
//     e.preventDefault();
    
//     const loginData = {
//       org_email: email,
//       password: password
//     };

//     const res = await dispatch(Login(loginData, navigate));
//     setMessage({status:res.success,text:res.message})
//     setTimeout(()=>{
//       setMessage(null)
//     },2000)
//   };

//   const handleManagerLogin = async (e) => {
//     e.preventDefault();
    
//     const loginData = {
//       manager_email: email,  // Using manager_email for manager login
//       manager_password: password
//     };

//     const res = await dispatch(Manager_Login(loginData, navigate));
//     setMessage({status:res.success,text:res.message})

//     setTimeout(()=>{
//       setMessage(null)
//     },2000)
//   };

//   const handleUserLogin = async (e) => {
//     e.preventDefault();

//     if (!email || !password) {
//       setMessage({ status: false, text: "Please fill in all fields" });
//       setTimeout(() => setMessage(null), 2000);
//       return;
//     }

//     if (!/\S+@\S+\.\S+/.test(email)) {
//       setMessage({ status: false, text: "Please enter a valid email address" });
//       setTimeout(() => setMessage(null), 2000);
//       return;
//     }

//     const loginData = {
//       user_email: email,
//       password: password
//     };

//     const res = await dispatch(UserLogin(loginData, navigate));
//     setMessage({status:res?.success,text:res?.message})

//     setTimeout(()=>{
//       setMessage(null)
//     },2000)
//   };

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     if (loginType === "organization") {
//       await handleOrganizationLogin(e);
//     } else if (loginType === "manager") {
//       await handleManagerLogin(e);
//     } else {
//       await handleUserLogin(e);
//     }
//   };

//   const handleSignup = async (e) => {
//     e.preventDefault();
    
//     // Validate passwords match
//     if (password !== confirmPassword) {
//       alert("Passwords don't match");
//       return;
//     }
//     // Prepare signup data according to API requirements
//     const signupData = {
//       org_name: fullName,
//       org_email: email,
//       password: password
//     };
//     // Dispatch signup action
//     await dispatch(Signup(signupData, navigate));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (isLogin) {
//       handleLogin(e);
//     } else {
//       handleSignup(e);
//     }
//   };

//   if (loading) {
//     return <StandardSpinner />
//   }

//   return (
//     <div className="min-h-screen font-sans bg-gradient-to-br from-[#0a0f1e] via-[#0b1425] to-[#0c1a2f] text-white overflow-hidden relative">
//       {/* Animated background orbs */}
//       <div className="absolute top-20 left-10 w-96 h-96 bg-blue-600/20 rounded-full blur-[100px] animate-pulse-slow"></div>
//       <div className="absolute bottom-20 right-10 w-96 h-96 bg-indigo-600/20 rounded-full blur-[100px] animate-pulse-slow animation-delay-2000"></div>
//       <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-500/10 rounded-full blur-[120px]"></div>
      
//       {/* Grid overlay */}
//
//       {/* Main Auth Container */}
//       <div className="container relative z-10 flex items-center min-h-screen px-6 mx-auto py-28">
//         <div className="flex flex-col items-center w-full gap-12 mx-auto lg:flex-row max-w-7xl">
          
//           {/* Left Side - 3D Logo with Circular Border */}
//           <div className="flex flex-col items-center flex-1 gap-8">
//             {/* 3D Animated Logo */}
//             <div className="relative w-80 h-80 lg:w-96 lg:h-96 animate-float-3d">
//               <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl rotate-6 transform-gpu animate-pulse-slow opacity-30 blur-3xl"></div>
//               <div className="absolute inset-0 overflow-hidden transition-all duration-700 border shadow-2xl bg-gradient-to-br from-blue-900/80 to-indigo-900/80 rounded-3xl transform-gpu rotate-3 hover:rotate-0 border-blue-500/30 backdrop-blur-sm">
//                 <div className="flex items-center justify-center w-full h-full bg-blue-500">
//                   <div className="p-8 text-center text-white">
//                     <div className="relative">
//                       {/* Circular Logo with Multiple Borders */}
//                       <div className="relative w-32 h-32 mx-auto">
//                         <div className="absolute inset-0 border-2 rounded-full border-blue-400/30 animate-spin-slow"></div>
//                         <div className="absolute inset-0 border-2 rounded-full border-indigo-400/50 animate-ping-slow"></div>
//                         <div className="absolute inset-0 rounded-full bg-blue-500/20 blur-xl animate-pulse"></div>
//                         <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 p-[3px]">
//                           <div className="w-full h-full rounded-full bg-[#0a0f1e] flex items-center justify-center overflow-hidden border-2 border-white/20">
//                             <img
//                               src={BMLogo}
//                               alt="AttendEase Logo"
//                               className="object-contain w-24 h-24 rounded-full animate-bounce-slow"
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="grid grid-cols-3 gap-3 mt-6">
//                       <div className="p-3 border rounded-lg bg-white/80 backdrop-blur-sm animate-pulse border-blue-400/30">
//                         <User className="w-6 h-6 mx-auto text-blue-300" />
//                       </div>
//                       <div className="p-3 delay-100 border rounded-lg bg-white/80 backdrop-blur-sm animate-pulse border-blue-400/30">
//                         <MapPin className="w-6 h-6 mx-auto text-blue-300" />
//                       </div>
//                       <div className="p-3 delay-200 border rounded-lg bg-white/80 backdrop-blur-sm animate-pulse border-blue-400/30">
//                         <Clock className="w-6 h-6 mx-auto text-blue-300" />
//                       </div>
//                     </div>
//                     <div className="flex items-center justify-center gap-2 mt-6 text-sm">
//                       <span className="w-2 h-2 bg-green-400 rounded-full animate-ping"></span>
//                       <span className="font-semibold text-blue-100">Secure • Fast • Reliable</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Side - Fixed Height Form Container */}
//           <div className="flex-1 w-full max-w-md mx-auto lg:mx-0">
//             <div className="bg-gradient-to-br from-blue-900/40 to-indigo-900/40 backdrop-blur-xl rounded-3xl border border-blue-500/30 p-8 shadow-2xl h-[680px] flex flex-col hover:border-blue-500/50 transition-all">
              
//               {/* Header */}
//               <div className="flex-shrink-0 mb-4 text-center">
//                 <h2 className="text-3xl font-bold text-transparent bg-gradient-to-r from-white to-blue-200 bg-clip-text">
//                   {isLogin ? "Welcome Back!" : "Start Your Journey"}
//                 </h2>
//                 <p className="mt-2 text-sm text-blue-100/70">
//                   {isLogin 
//                     ? "Sign in to access your secure dashboard" 
//                     : "Create your account at AttendEase"}
//                 </p>
//               </div>

//               {/* Login Type Toggle - Only show for login */}
//               {isLogin && (
//                 <div className="flex-shrink-0 mb-4">
//                   <label className="block mb-2 text-xs font-medium text-center text-blue-100">
//                     Sign in as
//                   </label>
//                   <div className="flex gap-2">
//                     <button
//                       type="button"
//                       onClick={() => setLoginType("organization")}
//                       className={`flex-1 py-2.5 px-2 rounded-xl flex items-center justify-center gap-1.5 transition-all ${
//                         loginType === "organization"
//                           ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-500/30 border border-blue-400'
//                           : 'bg-white/5 hover:bg-white/10 text-blue-100 border border-blue-500/30 hover:border-blue-400/50'
//                       }`}
//                     >
//                       <Building2 className="w-4 h-4" />
//                       <span className="text-xs">Organization</span>
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => setLoginType("manager")}
//                       className={`flex-1 py-2.5 px-2 rounded-xl flex items-center justify-center gap-1.5 transition-all ${
//                         loginType === "manager"
//                           ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-500/30 border border-blue-400'
//                           : 'bg-white/5 hover:bg-white/10 text-blue-100 border border-blue-500/30 hover:border-blue-400/50'
//                       }`}
//                     >
//                       <UserCog className="w-4 h-4" />
//                       <span className="text-xs">Manager</span>
//                     </button>
//                     <button
//                       type="button"
//                       onClick={() => setLoginType("user")}
//                       className={`flex-1 py-2.5 px-2 rounded-xl flex items-center justify-center gap-1.5 transition-all ${
//                         loginType === "user"
//                           ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-500/30 border border-blue-400'
//                           : 'bg-white/5 hover:bg-white/10 text-blue-100 border border-blue-500/30 hover:border-blue-400/50'
//                       }`}
//                     >
//                       <User className="w-4 h-4" />
//                       <span className="text-xs">User</span>
//                     </button>
//                   </div>
//                 </div>
//               )}

//               {/* Divider */}
//               <div className="relative flex-shrink-0 mb-4">
//                 <div className="absolute inset-0 flex items-center">
//                   <div className="w-full border-t border-blue-500/30"></div>
//                 </div>
//                 <div className="relative flex justify-center text-xs">
//                   <span className="px-4 bg-gradient-to-br from-blue-900/40 to-indigo-900/40 text-blue-200/60">
//                     {isLogin ? `sign in with ${loginType} email` : "sign up with email"}
//                   </span>
//                 </div>
//               </div>

//               {/* Form */}
//               <form onSubmit={handleSubmit} className="flex flex-col flex-1 min-h-0">
//                 <div className="flex-1 pr-1 overflow-y-auto custom-scrollbar">
//                   {!isLogin ? (
//                     <>
//                       {/* Signup Form (unchanged - Organization signup only) */}
//                       <div className="space-y-3">
//                         <div 
//                           ref={signupScrollRef}
//                           className="flex overflow-x-hidden scroll-smooth"
//                           style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
//                         >
//                           {/* Step 1: Personal Info */}
//                           <div className="min-w-full pr-1 space-y-3 transition-all">
//                             <div>
//                               <label className="block mb-1 text-xs font-medium text-blue-100">
//                                 Full Name
//                               </label>
//                               <div className="relative group">
//                                 <User className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                                 <input
//                                   type="text"
//                                   value={fullName}
//                                   onChange={(e) => setFullName(e.target.value)}
//                                   className="w-full pl-9 pr-3 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                                   placeholder="John Doe"
//                                   required
//                                 />
//                               </div>
//                             </div>

//                             <div>
//                               <label className="block mb-1 text-xs font-medium text-blue-100">
//                                 Email Address
//                               </label>
//                               <div className="relative group">
//                                 <Mail className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                                 <input
//                                   type="email"
//                                   value={email}
//                                   onChange={(e) => setEmail(e.target.value)}
//                                   className="w-full pl-9 pr-3 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                                   placeholder="you@company.com"
//                                   required
//                                 />
//                               </div>
//                             </div>
//                           </div>
//                         </div>

//                         {/* Password Fields */}
//                         <div className="pt-3 mt-3 space-y-3 border-t border-blue-500/20">
//                           <div>
//                             <label className="block mb-1 text-xs font-medium text-blue-100">
//                               Password
//                             </label>
//                             <div className="relative group">
//                               <Lock className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                               <input
//                                 type={showPassword ? "text" : "password"}
//                                 value={password}
//                                 onChange={(e) => setPassword(e.target.value)}
//                                 className="w-full pl-9 pr-9 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                                 placeholder="Create a strong password"
//                                 required
//                               />
//                               <button
//                                 type="button"
//                                 onClick={() => setShowPassword(!showPassword)}
//                                 className="absolute text-blue-400 transition transform -translate-y-1/2 right-3 top-1/2 hover:text-blue-300"
//                               >
//                                 {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
//                               </button>
//                             </div>
//                           </div>

//                           <div>
//                             <label className="block mb-1 text-xs font-medium text-blue-100">
//                               Confirm Password
//                             </label>
//                             <div className="relative group">
//                               <Lock className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                               <input
//                                 type={showPassword ? "text" : "password"}
//                                 value={confirmPassword}
//                                 onChange={(e) => setConfirmPassword(e.target.value)}
//                                 className="w-full pl-9 pr-3 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                                 placeholder="Confirm your password"
//                                 required
//                               />
//                             </div>
//                           </div>

//                           <div className="flex items-start gap-2">
//                             <input
//                               type="checkbox"
//                               id="terms"
//                               checked={agreeTerms}
//                               onChange={(e) => setAgreeTerms(e.target.checked)}
//                               className="w-3.5 h-3.5 mt-0.5 rounded border-blue-500/30 bg-white/5 text-blue-600 focus:ring-blue-500/20 focus:ring-offset-0"
//                               required
//                             />
//                             <label htmlFor="terms" className="text-xs text-blue-100/70">
//                               I agree to the{" "}
//                               <a href="#" className="text-blue-400 hover:text-blue-300">Terms</a>{" "}
//                               and{" "}
//                               <a href="#" className="text-blue-400 hover:text-blue-300">Privacy Policy</a>
//                             </label>
//                           </div>
//                         </div>
//                       </div>
//                     </>
//                   ) : (
//                     /* Login Form - shared by Organization / Manager / User */
//                     <div className="pt-2 space-y-4">
//                       <div>
//                         <label className="block mb-1 text-xs font-medium text-blue-100">
//                           {loginType === "organization" ? "Organization Email" : loginType === "manager" ? "Manager Email" : "User Email"}
//                         </label>
//                         <div className="relative group">
//                           <Mail className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                           <input
//                             type="email"
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                             className="w-full pl-9 pr-3 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                             placeholder={loginType === "organization" ? "org@company.com" : loginType === "manager" ? "manager@company.com" : "user@company.com"}
//                             required
//                           />
//                         </div>
//                       </div>

//                       <div>
//                         <label className="block mb-1 text-xs font-medium text-blue-100">
//                           Password
//                         </label>
//                         <div className="relative group">
//                           <Lock className="absolute text-blue-400 transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110" size={16} />
//                           <input
//                             type={showPassword ? "text" : "password"}
//                             value={password}
//                             onChange={(e) => setPassword(e.target.value)}
//                             className="w-full pl-9 pr-9 py-2.5 text-sm bg-white/5 border border-blue-500/30 rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 text-white placeholder-blue-200/50 transition group-hover:border-blue-400/50"
//                             placeholder="Enter your password"
//                             required
//                           />
//                           <button
//                             type="button"
//                             onClick={() => setShowPassword(!showPassword)}
//                             className="absolute text-blue-400 transition transform -translate-y-1/2 right-3 top-1/2 hover:text-blue-300"
//                           >
//                             {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
//                           </button>
//                         </div>
//                       </div>

//                       {/* Message/Error */}
//                       <div className="flex items-center justify-center">
//                         <span className={`text-xs ${message?.status?"text-green-400":"text-red-500"}`}>{message?.text}</span>
//                       </div>
                      
//                       {/* Spacing to match signup height */}
//                       <div className="h-[20px]"></div>
//                     </div>
//                   )}
//                 </div>

//                 {/* Submit Button */}
//                 <div className="flex-shrink-0 mt-4">
//                   <button
//                     type="submit"
//                     disabled={!isLogin && (!fullName || !email || !password || !confirmPassword || !agreeTerms)}
//                     className={`w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white font-semibold rounded-xl transition-all flex items-center justify-center gap-2 shadow-lg shadow-blue-500/30 ${
//                       !isLogin && (!fullName || !email || !password || !confirmPassword || !agreeTerms)
//                         ? 'opacity-50 cursor-not-allowed'
//                         : 'hover:scale-[1.02] active:scale-[0.98]'
//                     }`}
//                   >
//                     {isLogin ? (
//                       <>
//                         <Fingerprint className="w-4 h-4" />
//                         Sign In as {loginType === "organization" ? "Organization" : loginType === "manager" ? "Manager" : "User"}
//                       </>
//                     ) : (
//                       <>
//                         <User className="w-4 h-4" />
//                         Create Account
//                       </>
//                     )}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Custom Scrollbar Styles */}
//       <style jsx>{`
//         .custom-scrollbar::-webkit-scrollbar {
//           width: 4px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-track {
//           background: rgba(59, 130, 246, 0.1);
//           border-radius: 10px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb {
//           background: rgba(59, 130, 246, 0.3);
//           border-radius: 10px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//           background: rgba(59, 130, 246, 0.5);
//         }
        
//         @keyframes float-3d {
//           0%, 100% { transform: translateY(0px) rotate(0deg); }
//           50% { transform: translateY(-20px) rotate(2deg); }
//         }
//         .animate-float-3d {
//           animation: float-3d 6s ease-in-out infinite;
//         }
//         @keyframes pulse-slow {
//           0%, 100% { opacity: 0.2; }
//           50% { opacity: 0.4; }
//         }
//         .animate-pulse-slow {
//           animation: pulse-slow 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
//         }
//         @keyframes ping-slow {
//           75%, 100% { transform: scale(1.5); opacity: 0; }
//         }
//         .animate-ping-slow {
//           animation: ping-slow 3s cubic-bezier(0, 0, 0.2, 1) infinite;
//         }
//         @keyframes bounce-slow {
//           0%, 100% { transform: translateY(0); }
//           50% { transform: translateY(-10px); }
//         }
//         .animate-bounce-slow {
//           animation: bounce-slow 3s infinite;
//         }
//         @keyframes spin-slow {
//           from { transform: rotate(0deg); }
//           to { transform: rotate(360deg); }
//         }
//         .animate-spin-slow {
//           animation: spin-slow 8s linear infinite;
//         }
//         .delay-100 {
//           animation-delay: 100ms;
//         }
//         .delay-200 {
//           animation-delay: 200ms;
//         }
//         .animation-delay-2000 {
//           animation-delay: 2000ms;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AuthPages;

import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Clock, MapPin, Fingerprint, Lock, Eye, EyeOff, Building2, User, Mail, UserCog } from 'lucide-react';
import BMLogo from '../../assets/Logo of CICO time (1).png';
import { Signup, Login, Manager_Login } from "../../services/oprations/Auth";
import { UserLogin } from "../../services/oprations/User_Bussiness_Logic";
import StandardSpinner from "../../utils/Spinner";
import { useTheme } from "../../Context/themeContext";

const AuthPages = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [message ,setMessage] = useState(null)
  const [loading, setLoading] = useState(true);
  const [isLogin, setIsLogin] = useState(true);
  const [loginType, setLoginType] = useState("organization");
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [fullName, setFullName] = useState("");
  // eslint-disable-next-line
  const [companyName, setCompanyName] = useState("");
  // eslint-disable-next-line
  const [jobTitle, setJobTitle] = useState("");
  const [agreeTerms, setAgreeTerms] = useState(false);
  
  const signupScrollRef = useRef(null);
  // eslint-disable-next-line
  const [activeStep, setActiveStep] = useState(1);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  useEffect(() => {
    const userToken = localStorage.getItem('userToken');
    if (userToken) {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);
// eslint-disable-next-line
  const toggleAuthMode = (mode) => {
    setIsLogin(mode === 'login');
    setActiveStep(1);
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    setFullName("");
    setCompanyName("");
    setJobTitle("");
    setAgreeTerms(false);
    setLoginType("organization");
  };
// eslint-disable-next-line
    const scrollToNext = () => {
    if (signupScrollRef.current) {
      signupScrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
      setActiveStep(2);
    }
  };
// eslint-disable-next-line
    const scrollToPrev = () => {
    if (signupScrollRef.current) {
      signupScrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
      setActiveStep(1);
    }
  };

  const handleOrganizationLogin = async (e) => {
    e.preventDefault();
    const loginData = {
      org_email: email,
      password: password
    };
    const res = await dispatch(Login(loginData, navigate));
    setMessage({status:res.success,text:res.message})
    setTimeout(()=>{
      setMessage(null)
    },2000)
  };

  const handleManagerLogin = async (e) => {
    e.preventDefault();
    const loginData = {
      manager_email: email,
      manager_password: password
    };
    const res = await dispatch(Manager_Login(loginData, navigate));
    setMessage({status:res.success,text:res.message})
    setTimeout(()=>{
      setMessage(null)
    },2000)
  };

  const handleUserLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setMessage({ status: false, text: "Please fill in all fields" });
      setTimeout(() => setMessage(null), 2000);
      return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      setMessage({ status: false, text: "Please enter a valid email address" });
      setTimeout(() => setMessage(null), 2000);
      return;
    }
    const loginData = {
      user_email: email,
      password: password
    };
    const res = await dispatch(UserLogin(loginData, navigate));
    setMessage({status:res?.success,text:res?.message})
    setTimeout(()=>{
      setMessage(null)
    },2000)
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (loginType === "organization") {
      await handleOrganizationLogin(e);
    } else if (loginType === "manager") {
      await handleManagerLogin(e);
    } else {
      await handleUserLogin(e);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      alert("Passwords don't match");
      return;
    }
    const signupData = {
      org_name: fullName,
      org_email: email,
      password: password
    };
    await dispatch(Signup(signupData, navigate));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isLogin) {
      handleLogin(e);
    } else {
      handleSignup(e);
    }
  };

  if (loading) {
    return <StandardSpinner />
  }

  // Theme-aware background classes
  const bgGradient = theme === 'dark'
    ? 'bg-gradient-to-br from-[#0a0f1e] via-[#0b1425] to-[#0c1a2f]'
    : 'bg-gradient-to-br from-gray-100 via-gray-50 to-blue-50';

  const cardBg = theme === 'dark'
    ? 'bg-gradient-to-br from-blue-900/40 to-indigo-900/40 border-blue-500/30'
    : 'bg-gradient-to-br from-white/90 to-gray-50/90 border-gray-200';

  const inputBg = theme === 'dark'
    ? 'bg-white/5 border-blue-500/30 text-white placeholder-blue-200/50 group-hover:border-blue-400/50'
    : 'bg-gray-100/80 border-gray-300 text-gray-900 placeholder-gray-400 group-hover:border-blue-400/50';

  const inputIconColor = theme === 'dark' ? 'text-blue-400' : 'text-blue-600';
  const labelColor = theme === 'dark' ? 'text-blue-100' : 'text-gray-700';
  const textColor = theme === 'dark' ? 'text-white' : 'text-gray-900';
  const mutedTextColor = theme === 'dark' ? 'text-blue-100/70' : 'text-gray-600';

  // Orb colors based on theme
  const orbColors = theme === 'dark'
    ? ['bg-blue-600/20', 'bg-indigo-600/20', 'bg-blue-500/10']
    : ['bg-blue-400/20', 'bg-indigo-400/20', 'bg-blue-300/10'];

  return (
    <div className={`min-h-screen font-sans ${bgGradient} ${textColor} overflow-hidden relative transition-colors duration-300`}>
      {/* Animated background orbs */}
      <div className={`absolute top-20 left-10 w-96 h-96 ${orbColors[0]} rounded-full blur-[100px] animate-pulse-slow`}></div>
      <div className={`absolute bottom-20 right-10 w-96 h-96 ${orbColors[1]} rounded-full blur-[100px] animate-pulse-slow animation-delay-2000`}></div>
      <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] ${orbColors[2]} rounded-full blur-[120px]`}></div>
      
      {/* Grid overlay */}

      {/* Main Auth Container */}
      <div className="container relative z-10 flex items-center min-h-screen px-6 mx-auto py-28">
        <div className="flex flex-col items-center w-full gap-12 mx-auto lg:flex-row max-w-7xl">
          
          {/* Left Side - 3D Logo with Circular Border */}
          <div className="flex flex-col items-center flex-1 gap-8">
            {/* 3D Animated Logo */}
            <div className="relative w-80 h-80 lg:w-96 lg:h-96 animate-float-3d">
              <div className={`absolute inset-0 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl rotate-6 transform-gpu animate-pulse-slow opacity-30 blur-3xl`}></div>
              <div className={`absolute inset-0 overflow-hidden transition-all duration-700 border shadow-2xl bg-gradient-to-br from-blue-900/80 to-indigo-900/80 rounded-3xl transform-gpu rotate-3 hover:rotate-0 border-blue-500/30 backdrop-blur-sm`}>
                <div className="flex items-center justify-center w-full h-full bg-blue-500">
                  <div className="p-8 text-center text-white">
                    <div className="relative">
                      {/* Circular Logo with Multiple Borders */}
                      <div className="relative w-32 h-32 mx-auto">
                        <div className="absolute inset-0 border-2 rounded-full border-blue-400/30 animate-spin-slow"></div>
                        <div className="absolute inset-0 border-2 rounded-full border-indigo-400/50 animate-ping-slow"></div>
                        <div className="absolute inset-0 rounded-full bg-blue-500/20 blur-xl animate-pulse"></div>
                        <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-600 to-indigo-600 p-[3px]">
                          <div className="w-full h-full rounded-full bg-[#0a0f1e] flex items-center justify-center overflow-hidden border-2 border-white/20">
                            <img
                              src={BMLogo}
                              alt="AttendEase Logo"
                              className="object-contain w-24 h-24 rounded-full animate-bounce-slow"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-3 gap-3 mt-6">
                      <div className="p-3 border rounded-lg bg-white/80 backdrop-blur-sm animate-pulse border-blue-400/30">
                        <User className="w-6 h-6 mx-auto text-blue-600 dark:text-blue-300" />
                      </div>
                      <div className="p-3 delay-100 border rounded-lg bg-white/80 backdrop-blur-sm animate-pulse border-blue-400/30">
                        <MapPin className="w-6 h-6 mx-auto text-blue-600 dark:text-blue-300" />
                      </div>
                      <div className="p-3 delay-200 border rounded-lg bg-white/80 backdrop-blur-sm animate-pulse border-blue-400/30">
                        <Clock className="w-6 h-6 mx-auto text-blue-600 dark:text-blue-300" />
                      </div>
                    </div>
                    <div className="flex items-center justify-center gap-2 mt-6 text-sm">
                      <span className="w-2 h-2 bg-green-400 rounded-full animate-ping"></span>
                      <span className="font-semibold dark:text-blue-100">Secure • Fast • Reliable</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side - Fixed Height Form Container */}
          <div className="flex-1 w-full max-w-md mx-auto lg:mx-0">
            <div className={`${cardBg} backdrop-blur-xl rounded-3xl border p-8 shadow-2xl h-[680px] flex flex-col hover:border-blue-500/50 transition-all duration-300`}>
              
              {/* Header */}
              <div className="flex-shrink-0 mb-4 text-center">
                <h2 className={`text-3xl font-bold text-transparent bg-gradient-to-r ${theme === 'dark' ? 'from-white to-blue-200' : 'from-gray-900 to-blue-700'} bg-clip-text`}>
                  {isLogin ? "Welcome Back!" : "Start Your Journey"}
                </h2>
                <p className={`mt-2 text-sm ${mutedTextColor}`}>
                  {isLogin 
                    ? "Sign in to access your secure dashboard" 
                    : "Create your account at AttendEase"}
                </p>
              </div>

              {/* Login Type Toggle - Only show for login */}
              {isLogin && (
                <div className="flex-shrink-0 mb-4">
                  <label className={`block mb-2 text-xs font-medium text-center ${labelColor}`}>
                    Sign in as
                  </label>
                  <div className="flex gap-2">
                    <button
                      type="button"
                      onClick={() => setLoginType("organization")}
                      className={`flex-1 py-2.5 px-2 rounded-xl flex items-center justify-center gap-1.5 transition-all ${
                        loginType === "organization"
                          ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-500/30 border border-blue-400'
                          : theme === 'dark'
                            ? 'bg-white/5 hover:bg-white/10 text-blue-100 border border-blue-500/30 hover:border-blue-400/50'
                            : 'bg-gray-100/50 hover:bg-gray-200/50 text-gray-700 border border-gray-300 hover:border-blue-400/50'
                      }`}
                    >
                      <Building2 className="w-4 h-4" />
                      <span className="text-xs">Organization</span>
                    </button>
                    <button
                      type="button"
                      onClick={() => setLoginType("manager")}
                      className={`flex-1 py-2.5 px-2 rounded-xl flex items-center justify-center gap-1.5 transition-all ${
                        loginType === "manager"
                          ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-500/30 border border-blue-400'
                          : theme === 'dark'
                            ? 'bg-white/5 hover:bg-white/10 text-blue-100 border border-blue-500/30 hover:border-blue-400/50'
                            : 'bg-gray-100/50 hover:bg-gray-200/50 text-gray-700 border border-gray-300 hover:border-blue-400/50'
                      }`}
                    >
                      <UserCog className="w-4 h-4" />
                      <span className="text-xs">Manager</span>
                    </button>
                    <button
                      type="button"
                      onClick={() => setLoginType("user")}
                      className={`flex-1 py-2.5 px-2 rounded-xl flex items-center justify-center gap-1.5 transition-all ${
                        loginType === "user"
                          ? 'bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg shadow-blue-500/30 border border-blue-400'
                          : theme === 'dark'
                            ? 'bg-white/5 hover:bg-white/10 text-blue-100 border border-blue-500/30 hover:border-blue-400/50'
                            : 'bg-gray-100/50 hover:bg-gray-200/50 text-gray-700 border border-gray-300 hover:border-blue-400/50'
                      }`}
                    >
                      <User className="w-4 h-4" />
                      <span className="text-xs">User</span>
                    </button>
                  </div>
                </div>
              )}

              {/* Divider */}
              <div className="relative flex-shrink-0 mb-4">
                <div className="absolute inset-0 flex items-center">
                  <div className={`w-full border-t ${theme === 'dark' ? 'border-blue-500/30' : 'border-gray-300'}`}></div>
                </div>
                <div className="relative flex justify-center text-xs">
                  <span className={`px-4 ${theme === 'dark' ? 'bg-gradient-to-br from-blue-900/40 to-indigo-900/40 text-blue-200/60' : 'bg-white/90 text-gray-500'}`}>
                    {isLogin ? `sign in with ${loginType} email` : "sign up with email"}
                  </span>
                </div>
              </div>

              {/* Form */}
              <form onSubmit={handleSubmit} className="flex flex-col flex-1 min-h-0">
                <div className={`flex-1 pr-1 overflow-y-auto custom-scrollbar ${theme === 'dark' ? 'scrollbar-dark' : 'scrollbar-light'}`}>
                  {!isLogin ? (
                    <>
                      {/* Signup Form */}
                      <div className="space-y-3">
                        <div 
                          ref={signupScrollRef}
                          className="flex overflow-x-hidden scroll-smooth"
                          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
                        >
                          {/* Step 1: Personal Info */}
                          <div className="min-w-full pr-1 space-y-3 transition-all">
                            <div>
                              <label className={`block mb-1 text-xs font-medium ${labelColor}`}>
                                Full Name
                              </label>
                              <div className="relative group">
                                <User className={`absolute ${inputIconColor} transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110`} size={16} />
                                <input
                                  type="text"
                                  value={fullName}
                                  onChange={(e) => setFullName(e.target.value)}
                                  className={`w-full pl-9 pr-3 py-2.5 text-sm ${inputBg} rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 transition`}
                                  placeholder="John Doe"
                                  required
                                />
                              </div>
                            </div>

                            <div>
                              <label className={`block mb-1 text-xs font-medium ${labelColor}`}>
                                Email Address
                              </label>
                              <div className="relative group">
                                <Mail className={`absolute ${inputIconColor} transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110`} size={16} />
                                <input
                                  type="email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  className={`w-full pl-9 pr-3 py-2.5 text-sm ${inputBg} rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 transition`}
                                  placeholder="you@company.com"
                                  required
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* Password Fields */}
                        <div className={`pt-3 mt-3 space-y-3 border-t ${theme === 'dark' ? 'border-blue-500/20' : 'border-gray-300'}`}>
                          <div>
                            <label className={`block mb-1 text-xs font-medium ${labelColor}`}>
                              Password
                            </label>
                            <div className="relative group">
                              <Lock className={`absolute ${inputIconColor} transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110`} size={16} />
                              <input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className={`w-full pl-9 pr-9 py-2.5 text-sm ${inputBg} rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 transition`}
                                placeholder="Create a strong password"
                                required
                              />
                              <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className={`absolute ${inputIconColor} transition transform -translate-y-1/2 right-3 top-1/2 hover:text-blue-300`}
                              >
                                {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                              </button>
                            </div>
                          </div>

                          <div>
                            <label className={`block mb-1 text-xs font-medium ${labelColor}`}>
                              Confirm Password
                            </label>
                            <div className="relative group">
                              <Lock className={`absolute ${inputIconColor} transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110`} size={16} />
                              <input
                                type={showPassword ? "text" : "password"}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                className={`w-full pl-9 pr-3 py-2.5 text-sm ${inputBg} rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 transition`}
                                placeholder="Confirm your password"
                                required
                              />
                            </div>
                          </div>

                          <div className="flex items-start gap-2">
                            <input
                              type="checkbox"
                              id="terms"
                              checked={agreeTerms}
                              onChange={(e) => setAgreeTerms(e.target.checked)}
                              className={`w-3.5 h-3.5 mt-0.5 rounded ${theme === 'dark' ? 'border-blue-500/30 bg-white/5' : 'border-gray-300 bg-white'} text-blue-600 focus:ring-blue-500/20 focus:ring-offset-0`}
                              required
                            />
                            <label htmlFor="terms" className={`text-xs ${mutedTextColor}`}>
                              I agree to the{" "}
                              <span className="text-blue-400 hover:text-blue-300">Terms</span>{" "}
                              and{" "}
                              <span className="text-blue-400 hover:text-blue-300">Privacy Policy</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    /* Login Form */
                    <div className="pt-2 space-y-4">
                      <div>
                        <label className={`block mb-1 text-xs font-medium ${labelColor}`}>
                          {loginType === "organization" ? "Organization Email" : loginType === "manager" ? "Manager Email" : "User Email"}
                        </label>
                        <div className="relative group">
                          <Mail className={`absolute ${inputIconColor} transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110`} size={16} />
                          <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className={`w-full pl-9 pr-3 py-2.5 text-sm ${inputBg} rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 transition`}
                            placeholder={loginType === "organization" ? "org@company.com" : loginType === "manager" ? "manager@company.com" : "user@company.com"}
                            required
                          />
                        </div>
                      </div>

                      <div>
                        <label className={`block mb-1 text-xs font-medium ${labelColor}`}>
                          Password
                        </label>
                        <div className="relative group">
                          <Lock className={`absolute ${inputIconColor} transition transform -translate-y-1/2 left-3 top-1/2 group-hover:scale-110`} size={16} />
                          <input
                            type={showPassword ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className={`w-full pl-9 pr-9 py-2.5 text-sm ${inputBg} rounded-xl focus:outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-500/20 transition`}
                            placeholder="Enter your password"
                            required
                          />
                          <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className={`absolute ${inputIconColor} transition transform -translate-y-1/2 right-3 top-1/2 hover:text-blue-300`}
                          >
                            {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                          </button>
                        </div>
                      </div>

                      {/* Message/Error */}
                      <div className="flex items-center justify-center">
                        <span className={`text-xs ${message?.status ? "text-green-400" : "text-red-500"}`}>{message?.text}</span>
                      </div>
                      
                      {/* Spacing to match signup height */}
                      <div className="h-[20px]"></div>
                    </div>
                  )}
                </div>

                {/* Submit Button */}
                <div className="flex-shrink-0 mt-4">
                  <button
                    type="submit"
                    disabled={!isLogin && (!fullName || !email || !password || !confirmPassword || !agreeTerms)}
                    className={`w-full py-3 px-4 bg-gradient-to-r from-blue-600 to-blue-500 hover:from-blue-500 hover:to-blue-400 text-white font-semibold rounded-xl transition-all flex items-center justify-center gap-2 shadow-lg shadow-blue-500/30 ${
                      !isLogin && (!fullName || !email || !password || !confirmPassword || !agreeTerms)
                        ? 'opacity-50 cursor-not-allowed'
                        : 'hover:scale-[1.02] active:scale-[0.98]'
                    }`}
                  >
                    {isLogin ? (
                      <>
                        <Fingerprint className="w-4 h-4" />
                        Sign In as {loginType === "organization" ? "Organization" : loginType === "manager" ? "Manager" : "User"}
                      </>
                    ) : (
                      <>
                        <User className="w-4 h-4" />
                        Create Account
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Custom Scrollbar Styles */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: ${theme === 'dark' ? 'rgba(59, 130, 246, 0.1)' : 'rgba(0, 0, 0, 0.05)'};
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: ${theme === 'dark' ? 'rgba(59, 130, 246, 0.3)' : 'rgba(0, 0, 0, 0.15)'};
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: ${theme === 'dark' ? 'rgba(59, 130, 246, 0.5)' : 'rgba(0, 0, 0, 0.25)'};
        }
        
        @keyframes float-3d {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(2deg); }
        }
        .animate-float-3d {
          animation: float-3d 6s ease-in-out infinite;
        }
        @keyframes pulse-slow {
          0%, 100% { opacity: 0.2; }
          50% { opacity: 0.4; }
        }
        .animate-pulse-slow {
          animation: pulse-slow 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
        @keyframes ping-slow {
          75%, 100% { transform: scale(1.5); opacity: 0; }
        }
        .animate-ping-slow {
          animation: ping-slow 3s cubic-bezier(0, 0, 0.2, 1) infinite;
        }
        @keyframes bounce-slow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .animate-bounce-slow {
          animation: bounce-slow 3s infinite;
        }
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-spin-slow {
          animation: spin-slow 8s linear infinite;
        }
        .delay-100 {
          animation-delay: 100ms;
        }
        .delay-200 {
          animation-delay: 200ms;
        }
        .animation-delay-2000 {
          animation-delay: 2000ms;
        }
      `}</style>
    </div>
  );
};

export default AuthPages;
